import { withPrefix } from 'gatsby';
import React from 'react';
import { getIfUserHasPermissionsFunc } from '../../../src/helpers/pluginHandling/helpers';
import PrivateRoute from '../../gatsby-plugin-zefr-auth0/helpers/ProtectedRoute';
import DemoApp from './DemoApp';

export const DEMO_BASE_URL = process.env.GATSBY_DEMO_PATH || 'demo';
export const DEMO_FORM_URL = process.env.GATSBY_DEMO_FORM_PATH || 'form';

export const getDemoRouter: getIfUserHasPermissionsFunc<React.ReactNode> = (user) => {
  if (user?.authenticated) {
    return (
      <PrivateRoute
        component={DemoApp}
        key={DEMO_BASE_URL}
        path={withPrefix(`${DEMO_BASE_URL}/*`)}
      />
    );
  }
  return undefined;
};
